<template>
  <div class="edit-vehicle-passport">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Номер ПТС</label>
        <input type="text" class="form-control" v-model="data.number" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mb-2">
        <label>Наименование организации выдавшей ПТС</label>
        <textarea class="form-control" v-model="data.authority" placeholder required></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mb-2">
        <label>Дата выдачи</label>
        <input type="date" class="form-control" v-model="data.issue_date" placeholder required />
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-8 mb-2">
        <label>VIN</label>
        <input type="text" class="form-control" v-model="data.vin" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mb-2">
        <label>Тип ТС</label>
        <input type="text" class="form-control" v-model="data.vehicle_type" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 mb-2">
        <label>Номер кузова</label>
        <input type="text" class="form-control" v-model="data.body_number" placeholder required />
      </div>
      <div class="col-md-6 mb-2">
        <label>Номер двигателя</label>
        <input type="text" class="form-control" v-model="data.engine_number" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 mb-2">
        <label>Номер шасси (рамы)</label>
        <input type="text" class="form-control" v-model="data.chassis_number" placeholder required />
      </div>
      <div class="col-md-6 mb-2">
        <label>Цвет</label>
        <input type="text" class="form-control" v-model="data.color" placeholder required />
      </div>
    </div>
    <hr class="mb-4" />
  </div>
</template>

<script>
const type = 'vehicle_passport'

export default {
  name: 'DocumentVehiclePassportEdit',
  props: ['documentData'],
  data () {
    return {
      data: {
        vin: '',
        vehicle_type: 'ЛЕГКОВОЙ',
        body_number: '',
        engine_number: '',
        chassis_number: 'ОТСУТСТВУЕТ',
        color: 'БЕЛЫЙ',
        number: '',
        authority: '',
        issue_date: ''
      }
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
    this.update()
  },
  methods: {
    update () {
      this.$emit('update', {
        type: type,
        data: this.data
      })
    }
  },
  watch: {
    data: {
      handler () {
        this.update()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .edit-vehicle-passport input {
    margin-bottom: 5px;
  }
  .edit-vehicle-passport textarea {
    margin-bottom: 5px;
  }
</style>
